export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-04.23818f53.jpg";